// assets
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';

export const state = {
    colDef: [],
    dataGridState: {
        columns: {
            columnVisibilityModel: {},
            orderedFields: [],
            dimensions: {}
        },
        sorting: {
            sortModel: []
        },
        toolbarFilters: {}
    }
};

export const reducer = {
    setColDef(state, action) {
        if ('colDef' in (state || {})) {
            state.colDef = action?.payload;
        }
    },
    updateCols(state, action) {
        if ('colDef' in (state || {})) {
            [].concat(action?.payload).forEach((colData) => {
                const updColIndex = state.colDef.findIndex((col) => col?.field === colData?.field);
                if (updColIndex === -1) return;

                state.colDef.splice(updColIndex, 1, { ...state.colDef.at(updColIndex), ...colData });
            });
        }
    },
    toogleToolbarFilters(state, action) {
        if ('toolbarFilters' in (state?.dataGridState || {})) {
            const { filterName, filterValue } = action?.payload || {};
            state.dataGridState.toolbarFilters[filterName] = filterValue;
        }
    }
};

export const gridActions = (row, permissionData, onClickActions) => {
    const gridActions = [];

    permissionData?.forEach((perm) => {
        switch (perm) {
            case 'canView':
                gridActions.push({
                    key: `actionview-row${row?.id}`,
                    icon: <VisibilityTwoToneIcon fontSize="small" />,
                    label: 'ui-comp-button-view',
                    position: 1,
                    showInMenu: true,
                    onClick: () => {
                        if ('onClickRowActionView' in (onClickActions || {}) && typeof onClickActions.onClickRowActionView === 'function') {
                            onClickActions.onClickRowActionView(row);
                        }
                    }
                });
                break;
            case 'canEdit':
                if (row?.deletedAt) {
                    return;
                }

                gridActions.push({
                    key: `actionedit-row${row?.id}`,
                    icon: <EditTwoToneIcon fontSize="small" />,
                    label: 'ui-comp-button-edit',
                    position: 2,
                    showInMenu: true,
                    onClick: () => {
                        if ('onClickRowActionEdit' in (onClickActions || {}) && typeof onClickActions.onClickRowActionEdit === 'function') {
                            onClickActions.onClickRowActionEdit(row);
                        }
                    }
                });
                break;
            case 'canDelete':
                if (row?.deletedAt) {
                    return;
                }

                gridActions.push({
                    key: `actiondelete-row${row?.id}`,
                    icon: <DeleteTwoToneIcon fontSize="small" />,
                    label: 'ui-comp-button-delete',
                    position: 3,
                    showInMenu: true,
                    onClick: () => {
                        if (
                            'onClickRowActionDelete' in (onClickActions || {}) &&
                            typeof onClickActions.onClickRowActionDelete === 'function'
                        ) {
                            onClickActions.onClickRowActionDelete(row);
                        }
                    }
                });
                break;
            default: // do nothing
        }
    });

    return gridActions;
};
